// extracted by mini-css-extract-plugin
export var badge = "_fg-2";
export var detailsPanel = "_fg-0";
export var resultRow = "_fg-1";